import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const ChatGroupsList = Loadable(lazy(() => import('pages/chat/GroupsList')));
const ReportedMessagesList = Loadable(
    lazy(() => import('pages/chat/ReportedMessagesList')),
);
const ReportedMessageView = Loadable(
    lazy(() => import('pages/chat/ReportedMessageView')),
);
const ChatGroupCreate = Loadable(lazy(() => import('pages/chat/GroupCreate')));
const ChatGroupView = Loadable(lazy(() => import('pages/chat/GroupView')));
const ChatGroupEdit = Loadable(lazy(() => import('pages/chat/GroupEdit')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const ChatRoutes: RouteObject = {
    path: 'chat',
    children: [
        {
            path: 'groups',
            element: <ChatGroupsList />,
        },
        {
            path: 'reported-messages',
            element: <ReportedMessagesList />,
        },
        {
            path: 'reported-messages/:id',
            element: <ReportedMessageView />,
        },
        {
            path: 'groups/new',
            element: <ChatGroupCreate />,
        },
        {
            path: 'groups/:id',
            element: <ChatGroupView />,
        },
        {
            path: 'groups/:id/edit',
            element: <ChatGroupEdit />,
        },
    ],
};
export default ChatRoutes;
